export default {
  createSuccess: "Seller created successfully!",
  createModal: {
    title: "Add New Seller",
    namePlaceholder: "e.g. Acme Tours",
    emailPlaceholder: "seller@example.com",
    create: "Create Seller",
  },
  detail: {
    loadSeller: "Loading seller details...",
    loadError: "Failed to load seller",
    roleLabel: "Seller",
    statActivities: "Activities",
    bookingsCardTitle: "Bookings",
    seeBookings: "See bookings",
    toastPasswordResetSent: "Password reset email sent to the seller.",
    activitiesTitle: "Activities ({{count}})",
    addActivity: "Add activity",
    loadActivities: "Loading activities...",
    activitiesError: "Failed to load activities",
    noActivitiesTitle: "No activities",
    noActivitiesDesc: "This seller has no activities yet",
    toastStatusUpdated: "Seller status updated",
    toastStatusError: "Failed to update status",
    categoryRestaurant: "Restaurant",
    categoryService: "Service",
    categoryAttraction: "Experience",
    activityCommission: "Commission",
  },
} as const;
